<template>
	<NewsPage
		:newsHeaderTitle="newsHeaderTitle"
		:newsItems="newsItems"
		:isRecentNews="true"
	/>
</template>
<script>
import moment from 'moment';
import NewsPage from './newsPage.vue';
import axios from 'axios';
export default {
	name: "news",
	components: {
		NewsPage,
	},
	props: {
		query: String,
		newsPage: String,
	},
	data() {
		return {
			newsHeaderTitle: "Cyber Corner Latest News",
			newsItems: [],
		};
	},
	mounted() {
		this.getNewsPosts();
	},
	methods: {
		async getNewsPosts() {
			if (!this.$store.state.newsItems || this.$store.state.newsItems.length === 0) {
				try {
					const response = await axios.get("/api/resources/news");
					const newsItems = response.data.Items.sort((a, b) => new Date(a.date) < new Date(b.date) ? 1 : -1);
					this.$store.commit('setNewsItems', newsItems);
				} catch (error) {
					console.error(error);
				}
			}
			const _newsItems = this.$store.state.newsItems;
			const today = moment().valueOf();
			const fromTheLastSixMonths = moment().subtract(6, 'months').valueOf();
			// THIS RETRIEVES THE NEWS WITHIN THE LAST SIX MONTHS
			this.newsItems = _newsItems.filter(({ date }) => (moment(date).valueOf() > fromTheLastSixMonths) && (moment(date).valueOf() < today));
		},
	},
};
</script>
